<template>
  <div class="time-step-minutes-picker">
    <h3>Выберите шаг приема</h3>
    <div class="time-step-minutes-picker__control-panel">
      <button
        v-on:click="
          changeStylesOfButtons($event);
          onChangeTimeStep('15');
        "
        class="time-step-minutes-picker__button"
        type="button">
        15 минут
      </button>
      <button
        v-on:click="
          changeStylesOfButtons($event);
          onChangeTimeStep('30');
        "
        class="time-step-minutes-picker__button"
        type="button">
        30 минут
      </button>
      <button
        v-on:click="
          changeStylesOfButtons($event);
          onChangeTimeStep('60');
        "
        class="time-step-minutes-picker__button"
        type="button"
      >
        60 минут
      </button>
      <button
        class="time-step-minutes-picker__button-reset"
        type="button"
        v-on:click="
          resetStylesOfButtons();
          onChangeTimeStep('');
        "
      >Сбросить фильтр</button>
    </div>
  </div>
</template>

<script>
/**
 * @description Событие "Изменение шага приёма"
 * @type {string}
 */
const ON_CHANGE_TIME_STEP = 'change-time-step';
export default {
  name: 'TimeStepMinutesPicker',
  methods: {
    /**
     * @description Обработать событие изменения времени шага
     * @param value {string}
     * @return void
     */
    onChangeTimeStep(value) {
      this.$emit(ON_CHANGE_TIME_STEP, value);
    },
    /**
     * @description Меняем стили у кнопок
     * @return void
     */
    changeStylesOfButtons(event) {
      this.resetStylesOfButtons();
      event.target.classList.remove('time-step-minutes-picker__button');
      event.target.classList.add('time-step-minutes-picker__selected');
    },

    /**
     * @description Сбрасываем стили
     * @return void
     */
    resetStylesOfButtons() {
      document.querySelectorAll('.time-step-minutes-picker__selected').forEach((el) => {
        el.classList.remove('time-step-minutes-picker__selected');
        el.classList.add('time-step-minutes-picker__button');
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.time-step-minutes-picker {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
  &__control-panel {
    margin-top: 10px;
    display: flex;
    gap: 10px;
  }
  &__button {
    @include buttons.btn-transparent(76px, 36px, 14px);
  }
  &__button-reset {
    display: flex;
    align-items: center;
    height: 40px;
    font-size: 16px;
    line-height: 20px;
    color: #0489e0;
  }
  &__selected {
    @include buttons.btn-blue(76px, 36px, 14px);
  }
}
</style>
